var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _mask2, _g, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _mask3, _g2, _path139, _path140, _path141, _path142, _path143, _mask4, _g3, _path144, _path145, _path146, _path147, _mask5, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAibr4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1409,
    height: 1430,
    viewBox: "0 0 1409 1430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608.049 276.91C608.049 276.91 520.499 167.91 666.549 21C815.429 83.14 760.119 270.29 760.119 270.29",
    stroke: "#F4BE2A",
    strokeWidth: 34,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.709 283.67C406.709 283.67 728.709 357.1 963.109 252.6C1019.6 258.25 1214.73 608.47 1124.23 738.39C1033.73 868.31 285.229 907.85 248.549 724.27C211.869 540.69 362.819 275.43 406.709 283.67Z",
    fill: "#F4BE2A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.23 738.39C1132.7 726.22 1138.68 712.12 1142.49 696.56C670.699 903.56 333.579 651.64 251.049 579.75C241.829 629.34 239.539 679.26 248.549 724.27C285.259 907.85 1033.72 868.31 1124.23 738.39Z",
    fill: "#F4BE2A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M666.549 528.25C664.129 529.37 597.229 568.73 583.549 655.71",
    stroke: "#BD8D0A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M683.729 528.25C683.729 528.25 729.799 546.01 755.729 640.65",
    stroke: "#BD8D0A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.899 770.42C408.659 794.06 828.679 836.58 1161.19 726.92C1183.77 719.47 1208.38 728.07 1221.94 748.25C1306.03 873.34 1505.36 1132.05 1352.62 1307.41C1347.86 1312.88 1342.05 1317.32 1335.54 1320.49C1228.61 1372.49 716.829 1537.49 55.8787 1321.42C42.826 1317.1 31.9024 1307.98 25.3187 1295.91C-49.5313 1160.23 59.0787 939.67 124.849 828.09C149.399 786.45 195.309 763.81 241.899 770.42Z",
    fill: "#BD8D0A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.709 305.01C406.709 305.01 361.519 582.35 666.549 572.19C971.579 562.03 951.819 395.39 963.109 273.91C919.999 290.91 406.709 305.01 406.709 305.01Z",
    fill: "#F4BE2A"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 724,
    width: 1409,
    height: 706
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.899 770.42C408.659 794.06 828.679 836.58 1161.19 726.92C1183.77 719.47 1208.38 728.07 1221.94 748.25C1306.03 873.34 1505.36 1132.05 1352.62 1307.41C1347.86 1312.88 1342.05 1317.32 1335.54 1320.49C1228.61 1372.49 716.829 1537.49 55.8787 1321.42C42.826 1317.1 31.9024 1307.98 25.3187 1295.91C-49.5313 1160.23 59.0787 939.67 124.849 828.09C149.399 786.45 195.309 763.81 241.899 770.42Z",
    fill: "#097771"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M475.318 1077.96C488.391 1077.96 498.988 1067.16 498.988 1053.84C498.988 1040.52 488.391 1029.72 475.318 1029.72C462.246 1029.72 451.648 1040.52 451.648 1053.84C451.648 1067.16 462.246 1077.96 475.318 1077.96Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M486.079 1026.04C486.079 1026.04 498.389 1000.77 512.629 989.99",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M502.838 1034.76L532.568 1017.55",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M508.898 1056.8L548.898 1053.48",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M499.488 1075.7C505.562 1081.82 511.635 1087.93 517.708 1094.04",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M480.338 1084.1L490.028 1123.53",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M460.638 1083.38C457.212 1093.85 453.785 1104.33 450.358 1114.8",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M440.628 1053.91L403.938 1053.05",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M447.788 1032.91L416.588 1005.6",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M463.939 1025.03L458.429 992.12",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M441.548 1072.53L420.628 1084.13",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M790.669 1221.04C803.741 1221.04 814.339 1210.24 814.339 1196.92C814.339 1183.6 803.741 1172.8 790.669 1172.8C777.596 1172.8 766.999 1183.6 766.999 1196.92C766.999 1210.24 777.596 1221.04 790.669 1221.04Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M801.438 1169.12C801.438 1169.12 813.748 1143.85 827.988 1133.12",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M818.198 1177.84L847.928 1160.64",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M824.258 1199.91L864.258 1196.59",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M814.849 1218.79L833.059 1237.13",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M795.698 1227.19C798.925 1240.33 802.152 1253.47 805.378 1266.62",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M775.999 1226.47C772.579 1236.94 769.155 1247.41 765.729 1257.88",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M755.998 1196.97L719.318 1196.12",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M763.148 1175.97L731.948 1148.67",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M779.299 1168.12L773.789 1135.21",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M756.909 1215.62L735.999 1227.22",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1307.48 1099.61C1320.55 1099.61 1331.15 1088.81 1331.15 1075.49C1331.15 1062.17 1320.55 1051.37 1307.48 1051.37C1294.41 1051.37 1283.81 1062.17 1283.81 1075.49C1283.81 1088.81 1294.41 1099.61 1307.48 1099.61Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1318.25 1047.69C1318.25 1047.69 1330.56 1022.42 1344.8 1011.69",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1335 1056.41L1364.73 1039.2",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1341.07 1078.45L1381.07 1075.14",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1331.66 1097.36L1349.87 1115.69",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1312.51 1105.75C1315.74 1118.9 1318.97 1132.05 1322.19 1145.19",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1292.8 1105.03L1282.53 1136.45",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1272.79 1075.54L1236.11 1074.68",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1280 1054.54L1248.8 1027.23",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1296.11 1046.68L1290.6 1013.77",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1273.72 1094.18L1252.8 1105.78",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M631.578 826.61C644.651 826.61 655.248 815.811 655.248 802.49C655.248 789.169 644.651 778.37 631.578 778.37C618.506 778.37 607.908 789.169 607.908 802.49C607.908 815.811 618.506 826.61 631.578 826.61Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M642.338 774.69C642.338 774.69 654.658 749.42 668.898 738.69",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M659.108 783.41L688.838 766.21",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M665.168 805.45L705.168 802.14",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M655.758 824.36L673.998 842.69",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M636.608 832.76C639.842 845.9 643.068 859.044 646.288 872.19",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M616.898 832.03C613.478 842.51 610.055 852.984 606.628 863.45",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M596.888 802.54L560.208 801.68",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M604.058 781.54L572.858 754.24",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M620.208 773.69L614.698 740.77",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M597.818 821.19L576.898 832.78",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1308.84 775.8C1333.71 775.8 1353.88 755.635 1353.88 730.76C1353.88 705.885 1333.71 685.72 1308.84 685.72C1283.96 685.72 1263.8 705.885 1263.8 730.76C1263.8 755.635 1283.96 775.8 1308.84 775.8Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1372.75 736.29L1448.84 730.11",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1354.84 771.59L1389.5 805.83",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1318.4 787.27C1324.55 811.81 1330.69 836.35 1336.83 860.89",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1280.91 785.91C1274.39 805.47 1267.87 825.023 1261.36 844.57",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1242.84 730.91L1173.04 729.31",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1244.6 765.67L1204.79 787.32",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1087.62 1483.71C1112.49 1483.71 1132.66 1463.54 1132.66 1438.67C1132.66 1413.8 1112.49 1393.63 1087.62 1393.63C1062.74 1393.63 1042.58 1413.8 1042.58 1438.67C1042.58 1463.54 1062.74 1483.71 1087.62 1483.71Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1108.1 1386.77C1108.1 1386.77 1131.52 1339.59 1158.62 1319.47",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1140 1403.05L1196.57 1370.93",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1035.25 1399.56L975.889 1348.56",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1066 1384.91L1055.53 1323.46",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M880.519 958.43C905.393 958.43 925.559 938.265 925.559 913.39C925.559 888.515 905.393 868.35 880.519 868.35C855.644 868.35 835.479 888.515 835.479 913.39C835.479 938.265 855.644 958.43 880.519 958.43Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M900.999 861.49C900.999 861.49 924.419 814.31 951.519 794.19",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M932.889 877.77L989.459 845.65",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M944.429 918.91L1020.52 912.72",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M926.519 954.22L961.169 988.45",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M890.079 969.91C896.232 994.45 902.375 1018.99 908.509 1043.53",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M852.589 968.55C846.069 988.124 839.539 1007.68 832.999 1027.21",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M814.518 913.48L744.708 911.91",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M828.149 874.28L768.789 823.28",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M858.868 859.61L848.398 798.16",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M816.278 948.3L776.468 969.91",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M425.559 1386.17C442.624 1386.17 456.459 1372.34 456.459 1355.27C456.459 1338.2 442.624 1324.37 425.559 1324.37C408.493 1324.37 394.659 1338.2 394.659 1355.27C394.659 1372.34 408.493 1386.17 425.559 1386.17Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M439.599 1319.67C439.599 1319.67 455.669 1287.3 474.259 1273.5",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M461.488 1330.84L500.288 1308.84",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M469.398 1359.07L521.598 1354.82",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M457.108 1383.28L480.888 1406.76",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M432.119 1394.04L444.759 1444.54",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M406.399 1393.11L392.999 1433.35",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.278 1355.34L332.398 1354.24",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M389.629 1328.44L348.909 1293.44",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M410.709 1318.38L403.519 1276.23",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M381.489 1379.22L354.179 1394.07",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M201.278 1105.48C221.232 1105.48 237.408 1089.12 237.408 1068.95C237.408 1048.77 221.232 1032.42 201.278 1032.42C181.324 1032.42 165.148 1048.77 165.148 1068.95C165.148 1089.12 181.324 1105.48 201.278 1105.48Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M217.698 1026.85C217.698 1026.85 236.488 988.58 258.228 972.27",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.278 1040.06L288.648 1014",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M252.528 1073.44L313.528 1068.44",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M238.168 1102.07L265.968 1129.83",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M208.999 1114.79C213.919 1134.69 218.845 1154.59 223.779 1174.5",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.868 1113.69C173.635 1129.55 168.408 1145.41 163.188 1161.27",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M148.329 1069.03L92.3286 1067.73",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.269 1037.23L111.659 995.91",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M183.908 1025.33L175.508 975.49",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.748 1097.27L117.818 1114.82",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M542.889 1179.47C541.142 1179.47 539.403 1179.71 537.719 1180.17C537.719 1179.85 537.719 1179.52 537.719 1179.17C537.595 1174.18 535.535 1169.44 531.975 1165.94C528.415 1162.44 523.634 1160.47 518.644 1160.44C513.655 1160.4 508.848 1162.31 505.241 1165.76C501.634 1169.21 499.51 1173.92 499.319 1178.91C494.327 1178.91 489.54 1180.89 486.011 1184.42C482.481 1187.95 480.499 1192.74 480.499 1197.73C480.499 1202.72 482.481 1207.51 486.011 1211.04C489.54 1214.57 494.327 1216.55 499.319 1216.55V1216.82C499.319 1221.91 501.341 1226.8 504.942 1230.4C508.543 1234 513.426 1236.02 518.519 1236.02C523.611 1236.02 528.494 1234 532.095 1230.4C535.696 1226.8 537.719 1221.91 537.719 1216.82C537.719 1216.68 537.719 1216.54 537.719 1216.4C539.397 1216.86 541.129 1217.09 542.869 1217.09C547.863 1217.09 552.652 1215.11 556.183 1211.57C559.715 1208.04 561.699 1203.25 561.699 1198.26C561.699 1193.27 559.715 1188.48 556.183 1184.95C552.652 1181.41 547.863 1179.43 542.869 1179.43L542.889 1179.47ZM518.809 1198.03C520.465 1198.01 522.112 1197.78 523.709 1197.34C523.709 1197.66 523.709 1197.98 523.709 1198.34C523.709 1198.48 523.709 1198.62 523.709 1198.76C522.114 1198.33 520.471 1198.1 518.819 1198.08L518.809 1198.03Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M282.308 807.63C278.878 807.624 275.46 808.055 272.138 808.91C272.138 808.31 272.188 807.71 272.188 807.1C272.188 787.48 255.238 771.57 234.338 771.57C213.608 771.57 196.788 787.21 196.508 806.57C175.848 806.84 159.178 822.64 159.178 842.1C159.178 861.56 175.848 877.36 196.508 877.62C196.508 877.79 196.508 877.96 196.508 878.14C196.508 897.76 213.448 913.67 234.348 913.67C255.248 913.67 272.198 897.76 272.198 878.14C272.198 877.87 272.198 877.6 272.198 877.33C275.511 878.2 278.923 878.641 282.348 878.64C303.248 878.64 320.198 862.73 320.198 843.1C320.198 823.47 303.208 807.63 282.308 807.63ZM234.858 842.63C238.119 842.584 241.362 842.148 244.518 841.33C244.518 841.93 244.468 842.53 244.468 843.14C244.468 843.41 244.468 843.67 244.468 843.94C241.322 843.122 238.089 842.688 234.838 842.65L234.858 842.63Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1361.12 1262.31C1357.68 1262.31 1354.26 1262.75 1350.94 1263.62C1350.94 1263.02 1350.94 1262.42 1350.94 1261.81C1350.94 1242.19 1334 1226.28 1313.1 1226.28C1292.37 1226.28 1275.54 1241.92 1275.26 1261.28C1254.6 1261.55 1237.94 1277.35 1237.94 1296.81C1237.94 1316.27 1254.6 1332.07 1275.27 1332.33C1275.27 1332.5 1275.27 1332.67 1275.27 1332.85C1275.27 1352.47 1292.27 1368.38 1313.12 1368.38C1333.97 1368.38 1351 1352.51 1351 1332.91C1351 1332.64 1351 1332.37 1351 1332.1C1354.31 1332.97 1357.72 1333.41 1361.15 1333.41C1382.05 1333.41 1398.99 1317.5 1398.99 1297.87C1398.99 1278.24 1382 1262.31 1361.12 1262.31ZM1313.67 1297.31C1316.93 1297.26 1320.17 1296.83 1323.32 1296.01C1323.32 1296.61 1323.32 1297.21 1323.32 1297.82C1323.32 1298.09 1323.32 1298.35 1323.32 1298.62C1320.17 1297.8 1316.94 1297.37 1313.69 1297.33L1313.67 1297.31Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M844.308 1347.98C840.873 1347.98 837.452 1348.42 834.128 1349.29C834.128 1348.69 834.128 1348.08 834.128 1347.48C834.128 1327.85 817.188 1311.94 796.288 1311.94C775.558 1311.94 758.728 1327.59 758.448 1346.94C737.788 1347.2 721.128 1363 721.128 1382.46C721.128 1401.92 737.788 1417.72 758.458 1417.99C758.458 1418.16 758.458 1418.33 758.458 1418.5C758.458 1438.13 775.458 1454.04 796.308 1454.04C817.158 1454.04 834.148 1438.13 834.148 1418.5C834.148 1418.23 834.148 1417.96 834.148 1417.7C837.463 1418.56 840.874 1419 844.298 1419C865.198 1419 882.138 1403.09 882.138 1383.46C882.138 1363.83 865.208 1347.98 844.308 1347.98ZM796.858 1382.98C800.116 1382.94 803.357 1382.51 806.508 1381.68C806.508 1382.28 806.508 1382.89 806.508 1383.49C806.508 1383.76 806.508 1384.03 806.508 1384.3C803.363 1383.48 800.129 1383.04 796.878 1383.01L796.858 1382.98Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1210.5 883.91C1207.06 883.913 1203.64 884.353 1200.32 885.22C1200.32 884.62 1200.32 884.02 1200.32 883.41C1200.32 863.79 1183.38 847.88 1162.48 847.88C1141.75 847.88 1124.93 863.52 1124.65 882.88C1103.99 883.15 1087.32 898.95 1087.32 918.41C1087.32 937.87 1104 953.68 1124.7 953.91C1124.7 954.08 1124.7 954.25 1124.7 954.43C1124.7 974.05 1141.7 989.96 1162.55 989.96C1183.4 989.96 1200.39 974.05 1200.39 954.43C1200.39 954.16 1200.39 953.89 1200.39 953.62C1203.7 954.491 1207.11 954.932 1210.54 954.93C1231.44 954.93 1248.38 939.02 1248.38 919.39C1248.38 899.76 1231.4 883.91 1210.5 883.91ZM1163.05 918.91C1166.31 918.864 1169.55 918.427 1172.7 917.61C1172.7 918.21 1172.7 918.81 1172.7 919.42C1172.7 919.69 1172.7 919.95 1172.7 920.22C1169.55 919.401 1166.32 918.968 1163.07 918.93L1163.05 918.91Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M463.429 899.54C461.649 899.538 459.878 899.77 458.159 900.23C458.159 899.91 458.159 899.577 458.159 899.23C458.159 888.77 449.389 880.23 438.569 880.23C427.749 880.23 419.169 888.67 418.999 899.01C408.309 899.15 399.679 907.57 399.679 917.95C399.679 928.33 408.329 936.75 418.999 936.91C418.999 937.01 418.999 937.1 418.999 937.19C418.999 947.65 427.769 956.13 438.589 956.13C449.409 956.13 458.179 947.65 458.179 937.19C458.179 937.04 458.179 936.9 458.179 936.76C459.89 937.223 461.656 937.459 463.429 937.46C474.249 937.46 483.009 928.97 483.009 918.51C483.009 908.05 474.249 899.54 463.429 899.54ZM438.869 918.21C440.558 918.183 442.237 917.948 443.869 917.51C443.869 917.83 443.869 918.16 443.869 918.51C443.869 918.65 443.869 918.8 443.869 918.94C442.238 918.5 440.558 918.268 438.869 918.25V918.21Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1037.66 1046.39C1035.88 1046.39 1034.11 1046.63 1032.39 1047.09C1032.39 1046.77 1032.39 1046.45 1032.39 1046.09C1032.39 1035.63 1023.62 1027.15 1012.8 1027.15C1001.98 1027.15 993.368 1035.49 993.218 1045.83C982.528 1045.97 973.908 1054.39 973.908 1064.77C973.908 1075.15 982.528 1083.57 993.218 1083.71V1083.98C993.218 1094.44 1001.99 1102.98 1012.8 1102.98C1023.61 1102.98 1032.39 1094.49 1032.39 1083.98C1032.39 1083.84 1032.39 1083.7 1032.39 1083.55C1034.1 1084.01 1035.87 1084.25 1037.64 1084.25C1048.46 1084.25 1057.23 1075.77 1057.23 1065.3C1057.23 1054.83 1048.48 1046.39 1037.66 1046.39ZM1013.1 1065.06C1014.79 1065.04 1016.47 1064.81 1018.1 1064.37C1018.1 1064.69 1018.1 1065.02 1018.1 1065.37C1018.1 1065.52 1018.1 1065.66 1018.1 1065.8C1016.47 1065.36 1014.79 1065.13 1013.1 1065.11V1065.06Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1161.92 1140.52C1160.14 1140.52 1158.37 1140.76 1156.65 1141.22C1156.65 1140.9 1156.65 1140.57 1156.65 1140.22C1156.65 1129.76 1147.88 1121.27 1137.06 1121.27C1126.24 1121.27 1117.63 1129.62 1117.48 1139.96C1106.79 1140.1 1098.17 1148.52 1098.17 1158.9C1098.17 1169.28 1106.79 1177.69 1117.48 1177.83V1178.11C1117.48 1188.57 1126.25 1197.05 1137.06 1197.05C1147.87 1197.05 1156.65 1188.57 1156.65 1178.11C1156.65 1177.96 1156.65 1177.82 1156.65 1177.68C1158.36 1178.14 1160.13 1178.37 1161.9 1178.37C1172.72 1178.37 1181.49 1169.89 1181.49 1159.43C1181.49 1148.97 1172.74 1140.52 1161.92 1140.52ZM1137.36 1159.2C1139.05 1159.17 1140.73 1158.94 1142.36 1158.5C1142.36 1158.82 1142.36 1159.15 1142.36 1159.5C1142.36 1159.64 1142.36 1159.78 1142.36 1159.93C1140.73 1159.49 1139.05 1159.26 1137.36 1159.24V1159.2Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M429.538 679.26C427.759 679.258 425.987 679.49 424.268 679.95C424.268 679.63 424.268 679.297 424.268 678.95C424.268 668.49 415.498 659.95 404.678 659.95C393.858 659.95 385.248 668.3 385.098 678.64C374.408 678.78 365.778 687.2 365.778 697.58C365.778 707.96 374.408 716.38 385.098 716.52C385.098 716.61 385.098 716.7 385.098 716.79C385.098 727.25 393.868 735.73 404.688 735.73C415.508 735.73 424.298 727.34 424.298 716.91C424.298 716.77 424.298 716.62 424.298 716.48C426.01 716.943 427.775 717.179 429.548 717.18C440.368 717.18 449.138 708.69 449.138 698.18C449.138 687.67 440.358 679.26 429.538 679.26ZM404.998 697.91C406.687 697.881 408.365 697.65 409.998 697.22C409.998 697.54 409.998 697.874 409.998 698.22C409.998 698.36 409.998 698.51 409.998 698.65C408.367 698.21 406.687 697.978 404.998 697.96V697.91Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M234.568 1312.2C232.779 1312.2 230.997 1312.44 229.268 1312.9C229.268 1312.58 229.268 1312.26 229.268 1311.9C229.268 1301.5 220.458 1293.07 209.578 1293.07C198.698 1293.07 190.028 1301.36 189.888 1311.64C179.128 1311.78 170.458 1320.15 170.458 1330.46C170.458 1340.77 179.128 1349.14 189.888 1349.28C189.888 1349.37 189.888 1349.46 189.888 1349.55C189.888 1359.95 198.708 1368.38 209.588 1368.38C220.468 1368.38 229.278 1359.95 229.278 1349.55C229.278 1349.41 229.278 1349.27 229.278 1349.13C231.004 1349.59 232.783 1349.82 234.568 1349.82C245.438 1349.82 254.258 1341.39 254.258 1330.99C254.258 1320.59 245.438 1312.2 234.568 1312.2ZM209.868 1330.76C211.557 1330.74 213.237 1330.51 214.868 1330.07C214.868 1330.39 214.868 1330.71 214.868 1331.07C214.868 1331.21 214.868 1331.36 214.868 1331.5C213.236 1331.07 211.557 1330.84 209.868 1330.81V1330.76Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M664.548 1292.64C662.227 1292.64 659.917 1292.95 657.678 1293.57C657.678 1293.14 657.678 1292.72 657.678 1292.29C657.6 1285.59 654.897 1279.2 650.15 1274.47C645.403 1269.75 638.992 1267.08 632.295 1267.03C625.599 1266.98 619.151 1269.57 614.34 1274.23C609.529 1278.88 606.739 1285.25 606.568 1291.94C603.236 1291.87 599.924 1292.47 596.826 1293.7C593.728 1294.93 590.906 1296.77 588.526 1299.1C586.145 1301.43 584.254 1304.22 582.964 1307.29C581.673 1310.36 581.008 1313.66 581.008 1316.99C581.008 1320.33 581.673 1323.63 582.964 1326.7C584.254 1329.77 586.145 1332.56 588.526 1334.89C590.906 1337.22 593.728 1339.06 596.826 1340.29C599.924 1341.52 603.236 1342.12 606.568 1342.05C606.568 1342.18 606.568 1342.3 606.568 1342.42C606.568 1349.2 609.261 1355.7 614.055 1360.49C618.848 1365.29 625.349 1367.98 632.128 1367.98C638.907 1367.98 645.409 1365.29 650.202 1360.49C654.996 1355.7 657.688 1349.2 657.688 1342.42C657.688 1342.23 657.688 1342.04 657.688 1341.85C659.921 1342.46 662.224 1342.77 664.538 1342.77C667.872 1342.84 671.186 1342.24 674.285 1341.01C677.384 1339.78 680.207 1337.94 682.588 1335.61C684.97 1333.27 686.861 1330.49 688.153 1327.41C689.444 1324.34 690.109 1321.04 690.109 1317.71C690.109 1314.37 689.444 1311.07 688.153 1308C686.861 1304.92 684.97 1302.14 682.588 1299.8C680.207 1297.47 677.384 1295.63 674.285 1294.4C671.186 1293.17 667.872 1292.57 664.538 1292.64H664.548ZM632.548 1317.34C634.752 1317.32 636.943 1317.01 639.068 1316.43C639.068 1316.85 639.068 1317.28 639.068 1317.71C639.068 1317.9 639.068 1318.08 639.068 1318.27C636.945 1317.7 634.758 1317.39 632.558 1317.36L632.548 1317.34Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M688.088 1041.3C685.764 1041.3 683.45 1041.61 681.208 1042.22C681.208 1041.8 681.208 1041.37 681.208 1040.94C681.072 1034.28 678.342 1027.94 673.599 1023.26C668.856 1018.58 662.475 1015.94 655.814 1015.9C649.153 1015.85 642.737 1018.41 637.933 1023.02C633.128 1027.64 630.314 1033.94 630.088 1040.6C626.756 1040.53 623.444 1041.13 620.346 1042.36C617.248 1043.59 614.426 1045.43 612.046 1047.76C609.665 1050.09 607.774 1052.88 606.484 1055.95C605.193 1059.02 604.528 1062.32 604.528 1065.65C604.528 1068.99 605.193 1072.29 606.484 1075.36C607.774 1078.43 609.665 1081.22 612.046 1083.55C614.426 1085.88 617.248 1087.72 620.346 1088.95C623.444 1090.18 626.756 1090.78 630.088 1090.71C630.088 1090.83 630.088 1090.95 630.088 1091.07C630.221 1097.76 632.972 1104.14 637.752 1108.82C642.532 1113.51 648.959 1116.13 655.653 1116.13C662.347 1116.13 668.774 1113.51 673.554 1108.82C678.334 1104.14 681.086 1097.76 681.218 1091.07C681.218 1090.88 681.218 1090.69 681.218 1090.51C683.455 1091.11 685.762 1091.42 688.078 1091.42C691.369 1091.42 694.628 1090.77 697.668 1089.51C700.709 1088.25 703.471 1086.41 705.799 1084.08C708.126 1081.75 709.971 1078.99 711.231 1075.95C712.49 1072.91 713.138 1069.65 713.138 1066.36C713.138 1063.07 712.49 1059.81 711.231 1056.77C709.971 1053.73 708.126 1050.97 705.799 1048.64C703.471 1046.31 700.709 1044.47 697.668 1043.21C694.628 1041.95 691.369 1041.3 688.078 1041.3H688.088ZM655.998 1066C658.202 1065.97 660.393 1065.66 662.518 1065.08C662.518 1065.51 662.518 1065.93 662.518 1066.36C662.518 1066.55 662.518 1066.74 662.518 1066.93C660.399 1066.35 658.215 1066.04 656.018 1066.02L655.998 1066Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M990.269 1217.33C987.944 1217.33 985.63 1217.64 983.389 1218.26C983.389 1217.83 983.389 1217.41 983.389 1216.98C983.252 1210.32 980.522 1203.98 975.779 1199.3C971.036 1194.62 964.655 1191.98 957.994 1191.94C951.333 1191.89 944.917 1194.45 940.113 1199.06C935.308 1203.68 932.494 1209.98 932.269 1216.64C928.936 1216.57 925.624 1217.17 922.526 1218.4C919.428 1219.63 916.606 1221.47 914.226 1223.8C911.846 1226.13 909.955 1228.92 908.664 1231.99C907.373 1235.06 906.708 1238.36 906.708 1241.7C906.708 1245.03 907.373 1248.33 908.664 1251.4C909.955 1254.47 911.846 1257.26 914.226 1259.59C916.606 1261.92 919.428 1263.76 922.526 1264.99C925.624 1266.22 928.936 1266.82 932.269 1266.75C932.269 1266.87 932.269 1266.99 932.269 1267.11C932.401 1273.8 935.153 1280.18 939.933 1284.86C944.713 1289.55 951.14 1292.17 957.834 1292.17C964.528 1292.17 970.955 1289.55 975.735 1284.86C980.515 1280.18 983.266 1273.8 983.399 1267.11C983.399 1266.92 983.399 1266.73 983.399 1266.54C985.634 1267.15 987.941 1267.46 990.259 1267.46C993.592 1267.53 996.906 1266.93 1000.01 1265.7C1003.1 1264.47 1005.93 1262.63 1008.31 1260.3C1010.69 1257.96 1012.58 1255.18 1013.87 1252.1C1015.16 1249.03 1015.83 1245.73 1015.83 1242.39C1015.83 1239.06 1015.16 1235.76 1013.87 1232.69C1012.58 1229.61 1010.69 1226.83 1008.31 1224.49C1005.93 1222.16 1003.1 1220.32 1000.01 1219.09C996.906 1217.86 993.592 1217.26 990.259 1217.33H990.269ZM958.209 1242.03C960.415 1242 962.609 1241.7 964.739 1241.12C964.739 1241.54 964.739 1241.97 964.739 1242.4C964.739 1242.59 964.739 1242.77 964.739 1242.96C962.615 1242.39 960.428 1242.08 958.229 1242.05L958.209 1242.03Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M338.838 1174.03C336.518 1174.03 334.208 1174.34 331.968 1174.95C331.968 1174.53 331.968 1174.1 331.968 1173.68C331.89 1166.98 329.187 1160.59 324.44 1155.86C319.693 1151.14 313.282 1148.47 306.585 1148.42C299.889 1148.37 293.441 1150.96 288.63 1155.62C283.819 1160.28 281.029 1166.64 280.858 1173.33C277.526 1173.26 274.214 1173.86 271.116 1175.09C268.018 1176.32 265.196 1178.16 262.816 1180.49C260.435 1182.82 258.544 1185.61 257.254 1188.68C255.963 1191.75 255.298 1195.05 255.298 1198.39C255.298 1201.72 255.963 1205.02 257.254 1208.09C258.544 1211.16 260.435 1213.95 262.816 1216.28C265.196 1218.61 268.018 1220.45 271.116 1221.68C274.214 1222.91 277.526 1223.51 280.858 1223.44C280.858 1223.56 280.858 1223.68 280.858 1223.8C280.858 1230.58 283.551 1237.08 288.345 1241.87C293.138 1246.67 299.64 1249.36 306.418 1249.36C313.197 1249.36 319.699 1246.67 324.492 1241.87C329.286 1237.08 331.978 1230.58 331.978 1223.8C331.978 1223.61 331.978 1223.43 331.978 1223.24C334.211 1223.85 336.514 1224.16 338.828 1224.16C342.162 1224.23 345.476 1223.63 348.575 1222.4C351.674 1221.17 354.497 1219.33 356.878 1217C359.26 1214.66 361.151 1211.88 362.443 1208.8C363.734 1205.73 364.399 1202.43 364.399 1199.1C364.399 1195.76 363.734 1192.46 362.443 1189.39C361.151 1186.31 359.26 1183.53 356.878 1181.19C354.497 1178.86 351.674 1177.02 348.575 1175.79C345.476 1174.56 342.162 1173.96 338.828 1174.03H338.838ZM306.838 1198.73C309.041 1198.7 311.232 1198.39 313.358 1197.82C313.358 1198.24 313.358 1198.67 313.358 1199.09C313.358 1199.28 313.358 1199.47 313.358 1199.66C311.239 1199.08 309.055 1198.77 306.858 1198.75L306.838 1198.73Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M121.388 1174.97C119.064 1174.97 116.75 1175.28 114.508 1175.9C114.508 1175.47 114.508 1175.05 114.508 1174.62C114.43 1167.92 111.727 1161.53 106.98 1156.8C102.233 1152.08 95.8219 1149.41 89.1253 1149.36C82.4286 1149.31 75.9815 1151.9 71.1704 1156.56C66.3593 1161.22 63.5686 1167.58 63.3985 1174.27C60.0661 1174.2 56.7539 1174.8 53.6558 1176.03C50.5577 1177.26 47.7359 1179.1 45.3557 1181.43C42.9754 1183.76 41.0845 1186.55 39.7937 1189.62C38.5028 1192.69 37.8379 1195.99 37.8379 1199.33C37.8379 1202.66 38.5028 1205.96 39.7937 1209.03C41.0845 1212.1 42.9754 1214.89 45.3557 1217.22C47.7359 1219.55 50.5577 1221.39 53.6558 1222.62C56.7539 1223.85 60.0661 1224.45 63.3985 1224.38C63.3985 1224.5 63.3985 1224.62 63.3985 1224.75C63.3985 1231.53 66.0914 1238.03 70.8848 1242.82C75.6782 1247.62 82.1795 1250.31 88.9585 1250.31C95.7374 1250.31 102.239 1247.62 107.032 1242.82C111.826 1238.03 114.518 1231.53 114.518 1224.75C114.518 1224.56 114.518 1224.37 114.518 1224.18C116.754 1224.79 119.061 1225.1 121.378 1225.1C124.712 1225.17 128.026 1224.57 131.125 1223.34C134.224 1222.11 137.047 1220.27 139.428 1217.94C141.81 1215.6 143.701 1212.82 144.993 1209.74C146.284 1206.67 146.949 1203.37 146.949 1200.04C146.949 1196.7 146.284 1193.4 144.993 1190.33C143.701 1187.25 141.81 1184.47 139.428 1182.13C137.047 1179.8 134.224 1177.96 131.125 1176.73C128.026 1175.5 124.712 1174.9 121.378 1174.97H121.388ZM89.3285 1199.67C91.5349 1199.65 93.7292 1199.34 95.8585 1198.76C95.8585 1199.18 95.8585 1199.61 95.8585 1200.03C95.8585 1200.22 95.8585 1200.41 95.8585 1200.6C93.7349 1200.03 91.5479 1199.72 89.3485 1199.69L89.3285 1199.67Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1062 1246.78C1169.32 1167.7 1122.66 799.47 1058.64 784.17C1044.08 780.69 999.778 778.79 940.038 777.94C725.708 809.74 505.938 799.2 356.128 784.17C356.128 784.17 234.448 1133.8 307.888 1218.54C381.328 1303.28 954.638 1325.91 1062 1246.78Z",
    fill: "#F4BE2A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M309.309 1001.27L310.859 995.47",
    stroke: "#F4BE2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M314.009 983.75L356.519 825.49",
    stroke: "#F4BE2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "12.14 12.14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M358.099 819.63L359.659 813.83C359.659 813.83 361.729 813.92 365.659 814.06",
    stroke: "#F4BE2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M377.409 814.48C461.809 817.42 822.999 828.25 935.999 803.21",
    stroke: "#F4BE2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "11.78 11.78"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M941.688 801.85C943.688 801.337 945.615 800.81 947.468 800.27",
    stroke: "#F4BE2A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M406.709 283.67C406.709 283.67 361.519 561 666.549 550.84C971.579 540.68 951.819 374.05 963.109 252.6C919.999 269.55 406.709 283.67 406.709 283.67Z",
    fill: "#BD8D0A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M922.099 840.52C922.099 840.52 793.899 968.78 759.999 1013.97C726.099 1059.16 696.459 1122.69 656.919 1118.45C617.379 1114.21 545.999 1094.81 516.159 1092.72C486.319 1090.63 418.309 1117.45 385.829 1118.66C353.349 1119.87 289.829 1050.95 289.829 1050.95L529.269 1062.18L708.909 944.91L774.259 925.03L922.099 840.52Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M288.299 1048.78C288.299 1048.78 372.079 936.24 505.759 885.41C639.439 834.58 1039.12 790.25 1058.61 784.17C1078.1 778.09 738.069 885.52 738.069 885.52L459.539 1009.81L288.299 1048.78Z",
    fill: "#F4BE2A"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M562.999 902.74C610.309 972.93 640.169 1035.56 629.689 1042.62C619.209 1049.68 572.359 998.51 525.049 928.32C477.739 858.13 458.369 788.43 458.369 788.43C458.369 788.43 515.689 832.54 562.999 902.74Z",
    fill: "#0DA9A0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M507.858 834.4C505.966 837.549 503.544 840.347 500.698 842.67C495.379 847.173 488.712 849.777 481.748 850.07C477.418 840.48 473.748 831.62 470.668 823.79C473.698 823.52 476.629 822.577 479.248 821.03C479.568 820.84 479.898 820.64 480.248 820.42C482.971 818.582 485.15 816.047 486.558 813.08C493.208 819.48 498.068 824.3 501.448 827.73L502.448 828.79L502.828 829.17L503.828 830.23C504.518 830.94 505.218 831.66 505.908 832.39L506.958 833.49L507.858 834.4Z",
    fill: "#FFF5F9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M562.999 902.74C610.309 972.93 640.169 1035.56 629.689 1042.62C628.109 1043.69 625.689 1043.42 622.589 1041.97C621.589 1022.67 594.019 968.53 553.839 908.91C537.916 885.452 520.142 863.305 500.689 842.68C493.009 834.51 485.749 827.27 479.239 821.04C479.559 820.85 479.889 820.65 480.239 820.43C482.961 818.593 485.14 816.058 486.549 813.09C491.139 817.44 496.129 822.32 501.399 827.69V827.74L502.399 828.8L502.779 829.18L503.779 830.24C504.469 830.95 505.169 831.67 505.859 832.4L506.909 833.5C507.199 833.8 507.489 834.09 507.769 834.41C528.032 855.625 546.505 878.48 562.999 902.74Z",
    fill: "#7E1778"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M535.519 921.26C504.999 875.91 488.339 847.36 478.789 821.08C477.479 821.96 471.089 823.78 471.089 823.78C471.089 823.78 483.149 866.16 524.619 928.61C566.439 991.61 618.769 1049.98 629.249 1042.92C631.149 1041.64 631.719 1038.53 631.109 1033.92C612.709 1023.49 574.269 978.76 535.519 921.26Z",
    fill: "#10C9BE"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M505.689 961.03C557.459 1015.45 592.839 1065.83 584.689 1073.56C576.539 1081.29 527.999 1043.44 476.269 989.02C424.539 934.6 397.269 876.48 397.269 876.48C397.269 876.48 453.919 906.61 505.689 961.03Z",
    fill: "#3BC7F3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M447.339 909.39C446.165 912.428 444.473 915.24 442.339 917.7C438.351 922.421 432.904 925.679 426.859 926.96C421.649 919.21 417.119 912.01 413.269 905.61C415.882 904.927 418.311 903.669 420.379 901.93C420.629 901.71 420.889 901.49 421.139 901.25C423.251 899.24 424.787 896.703 425.589 893.9C432.339 898.51 437.309 902.01 440.779 904.51L441.839 905.28L442.229 905.57L443.279 906.34L445.419 907.92L446.499 908.72L447.339 909.39Z",
    fill: "#FFF5F9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.26
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M505.689 961.03C557.459 1015.45 592.839 1065.83 584.689 1073.56C583.469 1074.73 581.319 1074.85 578.379 1074.04C574.669 1057.3 542.539 1014.04 498.569 967.78C481.166 949.613 462.34 932.866 442.269 917.7C434.339 911.7 426.919 906.41 420.269 901.93C420.519 901.71 420.779 901.49 421.029 901.25C423.141 899.24 424.677 896.703 425.479 893.9C430.129 897.02 435.219 900.55 440.619 904.48H440.669L441.729 905.25L442.119 905.54L443.169 906.31L445.309 907.89L446.389 908.69L447.279 909.36C468.134 924.951 487.67 942.232 505.689 961.03Z",
    fill: "#3BC7F3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.42
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M484.379 981.3C450.949 946.14 432.179 923.61 419.939 902.03C418.939 903.03 413.599 905.53 413.599 905.53C413.599 905.53 430.419 940.82 475.929 989.34C521.829 1038.27 576.249 1081.61 584.369 1073.88C585.839 1072.49 585.879 1069.69 584.669 1065.73C566.999 1059.33 526.789 1025.91 484.379 981.3Z",
    fill: "#3BC7F3"
  }))), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.61 784.17C1058.61 784.17 481.938 884.61 289.858 1050.91C366.068 1136.77 462.078 1061.01 549.618 1077C637.158 1092.99 657.478 1101.84 695.328 1036.7C741.258 957.7 995.998 781.64 1058.61 784.17Z",
    fill: "#0B81A7"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 289,
    y: 784,
    width: 770,
    height: 309
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.61 784.17C1058.61 784.17 481.939 884.61 289.859 1050.91C366.069 1136.77 462.079 1061.01 549.619 1077C637.159 1092.99 657.479 1101.84 695.329 1036.7C741.259 957.7 995.999 781.64 1058.61 784.17Z",
    fill: "#FFE39B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.349 803.21C387.704 803.21 395.289 795.626 395.289 786.27C395.289 776.914 387.704 769.33 378.349 769.33C368.993 769.33 361.409 776.914 361.409 786.27C361.409 795.626 368.993 803.21 378.349 803.21Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.109 820.35C432.465 820.35 440.049 812.765 440.049 803.41C440.049 794.054 432.465 786.47 423.109 786.47C413.753 786.47 406.169 794.054 406.169 803.41C406.169 812.765 413.753 820.35 423.109 820.35Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.319 845.22C480.675 845.22 488.259 837.636 488.259 828.28C488.259 818.924 480.675 811.34 471.319 811.34C461.963 811.34 454.379 818.924 454.379 828.28C454.379 837.636 461.963 845.22 471.319 845.22Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.069 862.36C525.425 862.36 533.009 854.776 533.009 845.42C533.009 836.064 525.425 828.48 516.069 828.48C506.713 828.48 499.129 836.064 499.129 845.42C499.129 854.776 506.713 862.36 516.069 862.36Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.079 791.9C475.434 791.9 483.019 784.316 483.019 774.96C483.019 765.604 475.434 758.02 466.079 758.02C456.723 758.02 449.139 765.604 449.139 774.96C449.139 784.316 456.723 791.9 466.079 791.9Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.829 809.04C520.184 809.04 527.769 801.455 527.769 792.1C527.769 782.744 520.184 775.16 510.829 775.16C501.473 775.16 493.889 782.744 493.889 792.1C493.889 801.455 501.473 809.04 510.829 809.04Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.279 887.24C573.635 887.24 581.219 879.656 581.219 870.3C581.219 860.944 573.635 853.36 564.279 853.36C554.923 853.36 547.339 860.944 547.339 870.3C547.339 879.656 554.923 887.24 564.279 887.24Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.039 904.38C618.394 904.38 625.979 896.796 625.979 887.44C625.979 878.084 618.394 870.5 609.039 870.5C599.683 870.5 592.099 878.084 592.099 887.44C592.099 896.796 599.683 904.38 609.039 904.38Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.039 833.91C568.394 833.91 575.979 826.325 575.979 816.97C575.979 807.614 568.394 800.03 559.039 800.03C549.683 800.03 542.099 807.614 542.099 816.97C542.099 826.325 549.683 833.91 559.039 833.91Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.799 851.05C613.155 851.05 620.739 843.466 620.739 834.11C620.739 824.754 613.155 817.17 603.799 817.17C594.443 817.17 586.859 824.754 586.859 834.11C586.859 843.466 594.443 851.05 603.799 851.05Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.009 805.46C611.365 805.46 618.949 797.876 618.949 788.52C618.949 779.164 611.365 771.58 602.009 771.58C592.653 771.58 585.069 779.164 585.069 788.52C585.069 797.876 592.653 805.46 602.009 805.46Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.769 822.6C656.124 822.6 663.709 815.015 663.709 805.66C663.709 796.304 656.124 788.72 646.769 788.72C637.413 788.72 629.829 796.304 629.829 805.66C629.829 815.015 637.413 822.6 646.769 822.6Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.249 929.25C666.604 929.25 674.189 921.665 674.189 912.31C674.189 902.954 666.604 895.37 657.249 895.37C647.893 895.37 640.309 902.954 640.309 912.31C640.309 921.665 647.893 929.25 657.249 929.25Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.009 946.39C711.365 946.39 718.949 938.805 718.949 929.45C718.949 920.094 711.365 912.51 702.009 912.51C692.653 912.51 685.069 920.094 685.069 929.45C685.069 938.805 692.653 946.39 702.009 946.39Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.009 875.93C661.365 875.93 668.949 868.346 668.949 858.99C668.949 849.634 661.365 842.05 652.009 842.05C642.653 842.05 635.069 849.634 635.069 858.99C635.069 868.346 642.653 875.93 652.009 875.93Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.769 893.07C706.124 893.07 713.709 885.486 713.709 876.13C713.709 866.774 706.124 859.19 696.769 859.19C687.413 859.19 679.829 866.774 679.829 876.13C679.829 885.486 687.413 893.07 696.769 893.07Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.719 844.02C712.074 844.02 719.659 836.435 719.659 827.08C719.659 817.724 712.074 810.14 702.719 810.14C693.363 810.14 685.779 817.724 685.779 827.08C685.779 836.435 693.363 844.02 702.719 844.02Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.469 861.16C756.824 861.16 764.409 853.575 764.409 844.22C764.409 834.864 756.824 827.28 747.469 827.28C738.113 827.28 730.529 834.864 730.529 844.22C730.529 853.575 738.113 861.16 747.469 861.16Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.479 790.7C706.834 790.7 714.419 783.116 714.419 773.76C714.419 764.404 706.834 756.82 697.479 756.82C688.123 756.82 680.539 764.404 680.539 773.76C680.539 783.116 688.123 790.7 697.479 790.7Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.239 807.84C751.595 807.84 759.179 800.256 759.179 790.9C759.179 781.544 751.595 773.96 742.239 773.96C732.883 773.96 725.299 781.544 725.299 790.9C725.299 800.256 732.883 807.84 742.239 807.84Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.219 971.27C759.574 971.27 767.159 963.685 767.159 954.33C767.159 944.974 759.574 937.39 750.219 937.39C740.863 937.39 733.279 944.974 733.279 954.33C733.279 963.685 740.863 971.27 750.219 971.27Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.969 988.41C804.324 988.41 811.909 980.825 811.909 971.47C811.909 962.114 804.324 954.53 794.969 954.53C785.613 954.53 778.029 962.114 778.029 971.47C778.029 980.825 785.613 988.41 794.969 988.41Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.979 917.94C754.334 917.94 761.919 910.355 761.919 901C761.919 891.644 754.334 884.06 744.979 884.06C735.623 884.06 728.039 891.644 728.039 901C728.039 910.355 735.623 917.94 744.979 917.94Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.729 935.08C799.084 935.08 806.669 927.495 806.669 918.14C806.669 908.784 799.084 901.2 789.729 901.2C780.373 901.2 772.789 908.784 772.789 918.14C772.789 927.495 780.373 935.08 789.729 935.08Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.949 889.49C797.304 889.49 804.889 881.906 804.889 872.55C804.889 863.194 797.304 855.61 787.949 855.61C778.593 855.61 771.009 863.194 771.009 872.55C771.009 881.906 778.593 889.49 787.949 889.49Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.699 906.63C842.054 906.63 849.639 899.046 849.639 889.69C849.639 880.334 842.054 872.75 832.699 872.75C823.343 872.75 815.759 880.334 815.759 889.69C815.759 899.046 823.343 906.63 832.699 906.63Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.709 836.16C792.064 836.16 799.649 828.575 799.649 819.22C799.649 809.864 792.064 802.28 782.709 802.28C773.353 802.28 765.769 809.864 765.769 819.22C765.769 828.575 773.353 836.16 782.709 836.16Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.459 853.3C836.814 853.3 844.399 845.716 844.399 836.36C844.399 827.004 836.814 819.42 827.459 819.42C818.103 819.42 810.519 827.004 810.519 836.36C810.519 845.716 818.103 853.3 827.459 853.3Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.179 1013.28C852.534 1013.28 860.119 1005.7 860.119 996.34C860.119 986.984 852.534 979.4 843.179 979.4C833.823 979.4 826.239 986.984 826.239 996.34C826.239 1005.7 833.823 1013.28 843.179 1013.28Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.939 1030.42C897.294 1030.42 904.879 1022.84 904.879 1013.48C904.879 1004.12 897.294 996.54 887.939 996.54C878.583 996.54 870.999 1004.12 870.999 1013.48C870.999 1022.84 878.583 1030.42 887.939 1030.42Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.939 959.96C847.294 959.96 854.879 952.376 854.879 943.02C854.879 933.664 847.294 926.08 837.939 926.08C828.583 926.08 820.999 933.664 820.999 943.02C820.999 952.376 828.583 959.96 837.939 959.96Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.699 977.1C892.054 977.1 899.639 969.515 899.639 960.16C899.639 950.804 892.054 943.22 882.699 943.22C873.343 943.22 865.759 950.804 865.759 960.16C865.759 969.515 873.343 977.1 882.699 977.1Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.649 928.05C898.005 928.05 905.589 920.466 905.589 911.11C905.589 901.754 898.005 894.17 888.649 894.17C879.293 894.17 871.709 901.754 871.709 911.11C871.709 920.466 879.293 928.05 888.649 928.05Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.409 945.19C942.764 945.19 950.349 937.605 950.349 928.25C950.349 918.894 942.764 911.31 933.409 911.31C924.053 911.31 916.469 918.894 916.469 928.25C916.469 937.605 924.053 945.19 933.409 945.19Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.409 874.73C892.764 874.73 900.349 867.145 900.349 857.79C900.349 848.434 892.764 840.85 883.409 840.85C874.053 840.85 866.469 848.434 866.469 857.79C866.469 867.145 874.053 874.73 883.409 874.73Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.169 891.87C937.524 891.87 945.109 884.285 945.109 874.93C945.109 865.574 937.524 857.99 928.169 857.99C918.813 857.99 911.229 865.574 911.229 874.93C911.229 884.285 918.813 891.87 928.169 891.87Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.429 824.85C879.784 824.85 887.369 817.265 887.369 807.91C887.369 798.554 879.784 790.97 870.429 790.97C861.073 790.97 853.489 798.554 853.489 807.91C853.489 817.265 861.073 824.85 870.429 824.85Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.229 799.98C831.584 799.98 839.169 792.395 839.169 783.04C839.169 773.684 831.584 766.1 822.229 766.1C812.873 766.1 805.289 773.684 805.289 783.04C805.289 792.395 812.873 799.98 822.229 799.98Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.189 841.99C924.544 841.99 932.129 834.406 932.129 825.05C932.129 815.694 924.544 808.11 915.189 808.11C905.833 808.11 898.249 815.694 898.249 825.05C898.249 834.406 905.833 841.99 915.189 841.99Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.949 788.66C919.304 788.66 926.889 781.075 926.889 771.72C926.889 762.364 919.304 754.78 909.949 754.78C900.593 754.78 893.009 762.364 893.009 771.72C893.009 781.075 900.593 788.66 909.949 788.66Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.109 1069.97C330.465 1069.97 338.049 1062.39 338.049 1053.03C338.049 1043.67 330.465 1036.09 321.109 1036.09C311.753 1036.09 304.169 1043.67 304.169 1053.03C304.169 1062.39 311.753 1069.97 321.109 1069.97Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.859 1087.1C375.215 1087.1 382.799 1079.52 382.799 1070.16C382.799 1060.8 375.215 1053.22 365.859 1053.22C356.503 1053.22 348.919 1060.8 348.919 1070.16C348.919 1079.52 356.503 1087.1 365.859 1087.1Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.869 1016.64C325.224 1016.64 332.809 1009.06 332.809 999.7C332.809 990.344 325.224 982.76 315.869 982.76C306.513 982.76 298.929 990.344 298.929 999.7C298.929 1009.06 306.513 1016.64 315.869 1016.64Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.619 1033.78C369.974 1033.78 377.559 1026.2 377.559 1016.84C377.559 1007.48 369.974 999.9 360.619 999.9C351.263 999.9 343.679 1007.48 343.679 1016.84C343.679 1026.2 351.263 1033.78 360.619 1033.78Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.839 988.19C368.195 988.19 375.779 980.606 375.779 971.25C375.779 961.894 368.195 954.31 358.839 954.31C349.483 954.31 341.899 961.894 341.899 971.25C341.899 980.606 349.483 988.19 358.839 988.19Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.589 1005.33C412.945 1005.33 420.529 997.745 420.529 988.39C420.529 979.034 412.945 971.45 403.589 971.45C394.233 971.45 386.649 979.034 386.649 988.39C386.649 997.745 394.233 1005.33 403.589 1005.33Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.599 934.86C362.954 934.86 370.539 927.276 370.539 917.92C370.539 908.564 362.954 900.98 353.599 900.98C344.243 900.98 336.659 908.564 336.659 917.92C336.659 927.276 344.243 934.86 353.599 934.86Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.349 952C407.704 952 415.289 944.415 415.289 935.06C415.289 925.704 407.704 918.12 398.349 918.12C388.993 918.12 381.409 925.704 381.409 935.06C381.409 944.415 388.993 952 398.349 952Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.069 1111.98C423.425 1111.98 431.009 1104.4 431.009 1095.04C431.009 1085.68 423.425 1078.1 414.069 1078.1C404.713 1078.1 397.129 1085.68 397.129 1095.04C397.129 1104.4 404.713 1111.98 414.069 1111.98Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.829 1058.65C418.184 1058.65 425.769 1051.07 425.769 1041.71C425.769 1032.35 418.184 1024.77 408.829 1024.77C399.473 1024.77 391.889 1032.35 391.889 1041.71C391.889 1051.07 399.473 1058.65 408.829 1058.65Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.589 1075.79C462.945 1075.79 470.529 1068.21 470.529 1058.85C470.529 1049.49 462.945 1041.91 453.589 1041.91C444.233 1041.91 436.649 1049.49 436.649 1058.85C436.649 1068.21 444.233 1075.79 453.589 1075.79Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.539 1026.75C468.894 1026.75 476.479 1019.17 476.479 1009.81C476.479 1000.45 468.894 992.87 459.539 992.87C450.183 992.87 442.599 1000.45 442.599 1009.81C442.599 1019.17 450.183 1026.75 459.539 1026.75Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.299 1043.89C513.655 1043.89 521.239 1036.31 521.239 1026.95C521.239 1017.59 513.655 1010.01 504.299 1010.01C494.943 1010.01 487.359 1017.59 487.359 1026.95C487.359 1036.31 494.943 1043.89 504.299 1043.89Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.299 973.42C463.655 973.42 471.239 965.836 471.239 956.48C471.239 947.124 463.655 939.54 454.299 939.54C444.943 939.54 437.359 947.124 437.359 956.48C437.359 965.836 444.943 973.42 454.299 973.42Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.059 990.56C508.414 990.56 515.999 982.975 515.999 973.62C515.999 964.264 508.414 956.68 499.059 956.68C489.703 956.68 482.119 964.264 482.119 973.62C482.119 982.975 489.703 990.56 499.059 990.56Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.319 923.55C450.675 923.55 458.259 915.966 458.259 906.61C458.259 897.254 450.675 889.67 441.319 889.67C431.963 889.67 424.379 897.254 424.379 906.61C424.379 915.966 431.963 923.55 441.319 923.55Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.079 940.69C495.434 940.69 503.019 933.105 503.019 923.75C503.019 914.394 495.434 906.81 486.079 906.81C476.723 906.81 469.139 914.394 469.139 923.75C469.139 933.105 476.723 940.69 486.079 940.69Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.079 870.22C445.434 870.22 453.019 862.636 453.019 853.28C453.019 843.924 445.434 836.34 436.079 836.34C426.723 836.34 419.139 843.924 419.139 853.28C419.139 862.636 426.723 870.22 436.079 870.22Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.839 887.36C490.195 887.36 497.779 879.776 497.779 870.42C497.779 861.064 490.195 853.48 480.839 853.48C471.483 853.48 463.899 861.064 463.899 870.42C463.899 879.776 471.483 887.36 480.839 887.36Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.799 1100.67C511.155 1100.67 518.739 1093.09 518.739 1083.73C518.739 1074.37 511.155 1066.79 501.799 1066.79C492.443 1066.79 484.859 1074.37 484.859 1083.73C484.859 1093.09 492.443 1100.67 501.799 1100.67Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.559 1117.81C555.914 1117.81 563.499 1110.23 563.499 1100.87C563.499 1091.51 555.914 1083.93 546.559 1083.93C537.203 1083.93 529.619 1091.51 529.619 1100.87C529.619 1110.23 537.203 1117.81 546.559 1117.81Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.769 1072.22C554.124 1072.22 561.709 1064.64 561.709 1055.28C561.709 1045.92 554.124 1038.34 544.769 1038.34C535.413 1038.34 527.829 1045.92 527.829 1055.28C527.829 1064.64 535.413 1072.22 544.769 1072.22Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.529 1089.36C598.885 1089.36 606.469 1081.78 606.469 1072.42C606.469 1063.06 598.885 1055.48 589.529 1055.48C580.173 1055.48 572.589 1063.06 572.589 1072.42C572.589 1081.78 580.173 1089.36 589.529 1089.36Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.529 1018.89C548.885 1018.89 556.469 1011.31 556.469 1001.95C556.469 992.594 548.885 985.01 539.529 985.01C530.173 985.01 522.589 992.594 522.589 1001.95C522.589 1011.31 530.173 1018.89 539.529 1018.89Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.289 1036.03C593.644 1036.03 601.229 1028.45 601.229 1019.09C601.229 1009.73 593.644 1002.15 584.289 1002.15C574.933 1002.15 567.349 1009.73 567.349 1019.09C567.349 1028.45 574.933 1036.03 584.289 1036.03Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.469 1110.78C654.824 1110.78 662.409 1103.2 662.409 1093.84C662.409 1084.48 654.824 1076.9 645.469 1076.9C636.113 1076.9 628.529 1084.48 628.529 1093.84C628.529 1103.2 636.113 1110.78 645.469 1110.78Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.229 1057.45C649.584 1057.45 657.169 1049.87 657.169 1040.51C657.169 1031.15 649.584 1023.57 640.229 1023.57C630.873 1023.57 623.289 1031.15 623.289 1040.51C623.289 1049.87 630.873 1057.45 640.229 1057.45Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.989 1074.59C694.345 1074.59 701.929 1067.01 701.929 1057.65C701.929 1048.29 694.345 1040.71 684.989 1040.71C675.633 1040.71 668.049 1048.29 668.049 1057.65C668.049 1067.01 675.633 1074.59 684.989 1074.59Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.259 1007.58C636.615 1007.58 644.199 999.995 644.199 990.64C644.199 981.284 636.615 973.7 627.259 973.7C617.903 973.7 610.319 981.284 610.319 990.64C610.319 999.995 617.903 1007.58 627.259 1007.58Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.009 1024.72C681.365 1024.72 688.949 1017.14 688.949 1007.78C688.949 998.424 681.365 990.84 672.009 990.84C662.653 990.84 655.069 998.424 655.069 1007.78C655.069 1017.14 662.653 1024.72 672.009 1024.72Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.019 954.25C631.374 954.25 638.959 946.665 638.959 937.31C638.959 927.954 631.374 920.37 622.019 920.37C612.663 920.37 605.079 927.954 605.079 937.31C605.079 946.665 612.663 954.25 622.019 954.25Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.769 971.39C676.124 971.39 683.709 963.805 683.709 954.45C683.709 945.094 676.124 937.51 666.769 937.51C657.413 937.51 649.829 945.094 649.829 954.45C649.829 963.805 657.413 971.39 666.769 971.39Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.459 1102.92C734.814 1102.92 742.399 1095.34 742.399 1085.98C742.399 1076.62 734.814 1069.04 725.459 1069.04C716.103 1069.04 708.519 1076.62 708.519 1085.98C708.519 1095.34 716.103 1102.92 725.459 1102.92Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.219 1120.06C779.574 1120.06 787.159 1112.48 787.159 1103.12C787.159 1093.76 779.574 1086.18 770.219 1086.18C760.863 1086.18 753.279 1093.76 753.279 1103.12C753.279 1112.48 760.863 1120.06 770.219 1120.06Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.189 1091.61C822.544 1091.61 830.129 1084.03 830.129 1074.67C830.129 1065.31 822.544 1057.73 813.189 1057.73C803.833 1057.73 796.249 1065.31 796.249 1074.67C796.249 1084.03 803.833 1091.61 813.189 1091.61Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.659 1048.06C733.014 1048.06 740.599 1040.48 740.599 1031.12C740.599 1021.76 733.014 1014.18 723.659 1014.18C714.303 1014.18 706.719 1021.76 706.719 1031.12C706.719 1040.48 714.303 1048.06 723.659 1048.06Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.979 1066.73C774.334 1066.73 781.919 1059.15 781.919 1049.79C781.919 1040.43 774.334 1032.85 764.979 1032.85C755.623 1032.85 748.039 1040.43 748.039 1049.79C748.039 1059.15 755.623 1066.73 764.979 1066.73Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.949 1108.75C867.304 1108.75 874.889 1101.17 874.889 1091.81C874.889 1082.45 867.304 1074.87 857.949 1074.87C848.593 1074.87 841.009 1082.45 841.009 1091.81C841.009 1101.17 848.593 1108.75 857.949 1108.75Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.949 1038.28C817.304 1038.28 824.889 1030.7 824.889 1021.34C824.889 1011.98 817.304 1004.4 807.949 1004.4C798.593 1004.4 791.009 1011.98 791.009 1021.34C791.009 1030.7 798.593 1038.28 807.949 1038.28Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.979 996.27C724.334 996.27 731.919 988.685 731.919 979.33C731.919 969.974 724.334 962.39 714.979 962.39C705.623 962.39 698.039 969.974 698.039 979.33C698.039 988.685 705.623 996.27 714.979 996.27Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.189 1021.14C772.544 1021.14 780.129 1013.56 780.129 1004.2C780.129 994.844 772.544 987.26 763.189 987.26C753.833 987.26 746.249 994.844 746.249 1004.2C746.249 1013.56 753.833 1021.14 763.189 1021.14Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.709 1055.42C862.064 1055.42 869.649 1047.84 869.649 1038.48C869.649 1029.12 862.064 1021.54 852.709 1021.54C843.353 1021.54 835.769 1029.12 835.769 1038.48C835.769 1047.84 843.353 1055.42 852.709 1055.42Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.289 965.56C543.644 965.56 551.229 957.975 551.229 948.62C551.229 939.264 543.644 931.68 534.289 931.68C524.933 931.68 517.349 939.264 517.349 948.62C517.349 957.975 524.933 965.56 534.289 965.56Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.239 986.99C599.595 986.99 607.179 979.406 607.179 970.05C607.179 960.694 599.595 953.11 590.239 953.11C580.883 953.11 573.299 960.694 573.299 970.05C573.299 979.406 580.883 986.99 590.239 986.99Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.259 937.11C586.615 937.11 594.199 929.526 594.199 920.17C594.199 910.814 586.615 903.23 577.259 903.23C567.903 903.23 560.319 910.814 560.319 920.17C560.319 929.526 567.903 937.11 577.259 937.11Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.019 954.25C631.374 954.25 638.959 946.665 638.959 937.31C638.959 927.954 631.374 920.37 622.019 920.37C612.663 920.37 605.079 927.954 605.079 937.31C605.079 946.665 612.663 954.25 622.019 954.25Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.049 912.24C538.405 912.24 545.989 904.656 545.989 895.3C545.989 885.944 538.405 878.36 529.049 878.36C519.693 878.36 512.109 885.944 512.109 895.3C512.109 904.656 519.693 912.24 529.049 912.24Z",
    fill: "#A4E5F9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.76
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M947.468 830.56C939.918 833.33 931.468 836.63 922.098 840.56C811.328 886.44 655.708 1033.64 624.758 1047.45C593.808 1061.26 519.758 1020.08 408.828 1041.75C321.998 1058.75 297.258 1053.45 290.608 1050.36L289.858 1050.99C366.068 1136.85 462.078 1061.09 549.618 1077.08C637.158 1093.07 657.478 1101.92 695.328 1036.78C725.998 983.91 849.938 887.79 947.468 830.56Z",
    fill: "#0B81A7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1076 1233.91C1076 1233.91 1099.74 1126.05 1076 1077.09C1059.35 1122.69 1076 1233.91 1076 1233.91Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1062 1246.78C1049.49 1222.94 1066.44 1169.72 1021.25 1118.67C1026.87 1180.58 1062 1246.78 1062 1246.78Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.66 793.26C1047.79 817.91 995.599 837.77 983.789 904.91C1028.71 861.91 1058.66 793.26 1058.66 793.26Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M309.309 1227.25C326.059 1206.18 381.579 1200.16 410.009 1138.25C355.659 1168.39 309.309 1227.25 309.309 1227.25Z",
    fill: "#F4BE2A"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M143.449 1160.37C142.039 1101.37 184.139 979.48 229.599 877.91C230.958 874.87 231.58 871.552 231.413 868.226C231.246 864.901 230.295 861.661 228.637 858.773C226.979 855.885 224.662 853.43 221.875 851.608C219.088 849.786 215.909 848.649 212.599 848.29C183.599 845.1 167.509 834.99 158.539 824.86C149.169 814.3 132.219 815.65 125.019 827.79L124.829 828.11C81.8288 901.11 20.4888 1020.65 4.12882 1132.61C3.45774 1137.15 4.28422 1141.8 6.48339 1145.83C8.68256 1149.86 12.1349 1153.07 16.3188 1154.97C49.2572 1170.03 84.5902 1179.17 120.699 1181.97C123.646 1182.2 126.609 1181.8 129.394 1180.81C132.18 1179.82 134.727 1178.26 136.871 1176.22C139.015 1174.19 140.708 1171.72 141.841 1168.99C142.974 1166.26 143.522 1163.33 143.449 1160.37Z",
    fill: "#F4BE2A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14844 1132.61C4.14844 1132.61 18.7184 1083.61 42.7184 1077.04L4.14844 1132.61Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M120.719 1181.98C120.719 1181.98 82.2589 1094.82 94.9989 1036.74C110.499 1078.91 120.719 1181.98 120.719 1181.98Z",
    fill: "#F4BE2A"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M212.619 848.29C183.619 845.1 167.529 834.99 158.559 824.86C149.189 814.3 132.239 815.65 125.039 827.79L124.849 828.11C124.849 828.11 120.849 916.19 229.599 877.91C230.958 874.872 231.58 871.555 231.414 868.231C231.248 864.906 230.299 861.668 228.643 858.781C226.988 855.893 224.673 853.437 221.889 851.614C219.104 849.791 215.928 848.652 212.619 848.29Z",
    fill: "#0B81A7"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 817,
    width: 108,
    height: 71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.619 848.29C183.619 845.1 167.529 834.99 158.559 824.86C149.189 814.3 132.239 815.65 125.039 827.79L124.849 828.11C124.849 828.11 120.849 916.19 229.599 877.91C230.958 874.872 231.58 871.555 231.414 868.231C231.248 864.906 230.299 861.668 228.643 858.781C226.988 855.893 224.673 853.437 221.889 851.614C219.104 849.791 215.928 848.652 212.619 848.29Z",
    fill: "#FFE39B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.089 920.24C140.445 920.24 148.029 912.656 148.029 903.3C148.029 893.944 140.445 886.36 131.089 886.36C121.733 886.36 114.149 893.944 114.149 903.3C114.149 912.656 121.733 920.24 131.089 920.24Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.149 835.51C123.505 835.51 131.089 827.926 131.089 818.57C131.089 809.214 123.505 801.63 114.149 801.63C104.793 801.63 97.209 809.214 97.209 818.57C97.209 827.926 104.793 835.51 114.149 835.51Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.039 869.4C157.394 869.4 164.979 861.816 164.979 852.46C164.979 843.104 157.394 835.52 148.039 835.52C138.683 835.52 131.099 843.104 131.099 852.46C131.099 861.816 138.683 869.4 148.039 869.4Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.929 911.76C191.284 911.76 198.869 904.176 198.869 894.82C198.869 885.464 191.284 877.88 181.929 877.88C172.573 877.88 164.989 885.464 164.989 894.82C164.989 904.176 172.573 911.76 181.929 911.76Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.869 860.93C208.224 860.93 215.809 853.346 215.809 843.99C215.809 834.634 208.224 827.05 198.869 827.05C189.513 827.05 181.929 834.634 181.929 843.99C181.929 853.346 189.513 860.93 198.869 860.93Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.979 818.57C174.335 818.57 181.919 810.986 181.919 801.63C181.919 792.274 174.335 784.69 164.979 784.69C155.623 784.69 148.039 792.274 148.039 801.63C148.039 810.986 155.623 818.57 164.979 818.57Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.759 894.82C242.115 894.82 249.699 887.236 249.699 877.88C249.699 868.524 242.115 860.94 232.759 860.94C223.403 860.94 215.819 868.524 215.819 877.88C215.819 887.236 223.403 894.82 232.759 894.82Z",
    fill: "#A4E5F9"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M124.849 828.11C124.849 828.11 120.509 917.19 229.599 877.91",
    stroke: "#F4BE2A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.4 435.16C1055.4 450.16 1025.04 473.1 991.619 480.07C988.898 480.649 986.358 481.877 984.214 483.649C982.07 485.421 980.386 487.685 979.306 490.249C978.226 492.812 977.781 495.598 978.01 498.37C978.238 501.142 979.133 503.818 980.619 506.17C1019.26 567.17 1043.43 653.59 1021.21 680.74C1004.11 701.65 1086.78 691.99 1146.55 672.85C1153.98 603.09 1127.55 512.15 1091.68 432.7C1088.59 431.13 1085.1 430.526 1081.66 430.964C1078.22 431.403 1075 432.865 1072.4 435.16Z",
    fill: "#BD8D0A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.58 655.71C1077.17 680.19 1021.22 680.71 1021.22 680.71L1020.16 682.2C1008.61 700.48 1088.96 690.2 1146.56 672.82C1132.25 667.01 1117.17 673.8 1102.58 655.71Z",
    fill: "#F4BE2A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M226.369 882.91C226.369 882.91 196.969 896.21 178.139 911.7C197.999 922.22 228.669 880.36 226.369 882.91Z",
    fill: "#F4BE2A"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.4 435.16C1055.4 450.16 1025.04 473.1 991.619 480.07C988.472 480.727 985.575 482.257 983.256 484.483C980.938 486.709 979.293 489.543 978.509 492.66C978.509 492.66 1085.51 563.66 1091.69 432.66C1088.59 431.094 1085.1 430.494 1081.66 430.94C1078.22 431.386 1074.99 432.856 1072.4 435.16Z",
    fill: "#0B81A7"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 978,
    y: 430,
    width: 114,
    height: 82
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.4 435.16C1055.4 450.16 1025.04 473.1 991.619 480.07C988.472 480.727 985.575 482.257 983.256 484.483C980.938 486.709 979.293 489.543 978.509 492.66C978.509 492.66 1085.51 563.66 1091.69 432.66C1088.59 431.094 1085.1 430.494 1081.66 430.94C1078.22 431.386 1074.99 432.856 1072.4 435.16Z",
    fill: "#FFE39B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M990.099 514.97C999.454 514.97 1007.04 507.386 1007.04 498.03C1007.04 488.675 999.454 481.09 990.099 481.09C980.743 481.09 973.159 488.675 973.159 498.03C973.159 507.386 980.743 514.97 990.099 514.97Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.82 540.39C1084.17 540.39 1091.76 532.806 1091.76 523.45C1091.76 514.095 1084.17 506.51 1074.82 506.51C1065.46 506.51 1057.88 514.095 1057.88 523.45C1057.88 532.806 1065.46 540.39 1074.82 540.39Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.04 455.671C1016.39 455.671 1023.98 448.086 1023.98 438.73C1023.98 429.375 1016.39 421.791 1007.04 421.791C997.683 421.791 990.099 429.375 990.099 438.73C990.099 448.086 997.683 455.671 1007.04 455.671Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.76 455.671C1069.11 455.671 1076.7 448.086 1076.7 438.73C1076.7 429.375 1069.11 421.791 1059.76 421.791C1050.4 421.791 1042.82 429.375 1042.82 438.73C1042.82 448.086 1050.4 455.671 1059.76 455.671Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.82 498.03C1052.17 498.03 1059.76 490.446 1059.76 481.09C1059.76 471.735 1052.17 464.15 1042.82 464.15C1033.46 464.15 1025.88 471.735 1025.88 481.09C1025.88 490.446 1033.46 498.03 1042.82 498.03Z",
    fill: "#A4E5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.53 498.03C1104.88 498.03 1112.47 490.446 1112.47 481.09C1112.47 471.735 1104.88 464.15 1095.53 464.15C1086.17 464.15 1078.59 471.735 1078.59 481.09C1078.59 490.446 1086.17 498.03 1095.53 498.03Z",
    fill: "#A4E5F9"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M978.049 492.19C978.049 492.19 1084.27 565.19 1091.23 432.19",
    stroke: "#F4BE2A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88867 1259C13.7092 1271.82 18.8817 1284.19 25.3187 1295.91C31.9063 1307.97 42.8294 1317.08 55.8787 1321.4C716.879 1537.51 1228.61 1372.51 1335.54 1320.47C1342.05 1317.3 1347.86 1312.86 1352.62 1307.39C1358.26 1300.92 1363.55 1294.15 1368.47 1287.12C1061 1390.35 632.599 1441.09 9.88867 1259Z",
    fill: "#F4BE2A"
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M586.519 640.65C586.519 640.65 545.389 656.97 546.799 673.8C548.209 690.63 595.999 702.91 605.999 692.51C615.999 682.11 586.519 640.65 586.519 640.65Z",
    fill: "#BD8D0A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M753.348 626.52C753.348 626.52 721.788 657.52 729.628 672.52C737.468 687.52 786.228 680.2 791.428 666.77C796.628 653.34 753.348 626.52 753.348 626.52Z",
    fill: "#BD8D0A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.47
  }, _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 404,
    y: 252,
    width: 560,
    height: 300
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.709 283.67C406.709 283.67 361.519 561 666.549 550.84C971.579 540.68 951.819 374.05 963.109 252.6C919.999 269.55 406.709 283.67 406.709 283.67Z",
    fill: "#004F68"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M902.679 345.47C915.751 345.47 926.349 334.671 926.349 321.35C926.349 308.029 915.751 297.23 902.679 297.23C889.606 297.23 879.009 308.029 879.009 321.35C879.009 334.671 889.606 345.47 902.679 345.47Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.438 293.55C913.438 293.55 925.748 268.28 939.998 257.55",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.209 302.27L959.939 285.07",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.269 324.31L976.269 321",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.859 343.22L945.069 361.55",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.709 351.62C910.942 364.76 914.169 377.903 917.389 391.05",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.999 350.91C884.579 361.39 881.155 371.864 877.729 382.33",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.999 321.4L831.319 320.54",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.159 300.4L843.999 273.1",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.299 292.55L885.799 259.63",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.919 340.05L847.999 351.64",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.569 510.6C554.635 510.6 568.469 496.766 568.469 479.7C568.469 462.635 554.635 448.8 537.569 448.8C520.503 448.8 506.669 462.635 506.669 479.7C506.669 496.766 520.503 510.6 537.569 510.6Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.609 444.1C551.609 444.1 567.679 411.73 586.269 397.93",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.489 455.26L612.299 433.26",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.409 483.49L633.609 479.25",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.119 507.71L592.889 531.19",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.129 518.46C548.342 535.3 552.556 552.137 556.769 568.97",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.409 517.54C513.929 530.947 509.455 544.36 504.989 557.78",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.289 479.76L444.399 478.67",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.639 452.91L460.919 417.91",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.719 442.81L515.529 400.65",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.498 503.65L466.188 518.5",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.899 303.91C653.152 303.909 651.414 304.141 649.729 304.6C649.729 304.293 649.729 303.96 649.729 303.6C649.604 298.612 647.542 293.868 643.982 290.373C640.421 286.878 635.639 284.905 630.65 284.872C625.66 284.84 620.854 286.75 617.248 290.199C613.642 293.648 611.519 298.364 611.329 303.35C606.337 303.35 601.55 305.333 598.021 308.862C594.492 312.392 592.509 317.179 592.509 322.17C592.509 327.161 594.492 331.948 598.021 335.478C601.55 339.007 606.337 340.99 611.329 340.99V341.26C611.329 346.352 613.352 351.236 616.952 354.837C620.553 358.437 625.437 360.46 630.529 360.46C635.621 360.46 640.505 358.437 644.105 354.837C647.706 351.236 649.729 346.352 649.729 341.26C649.729 341.12 649.729 340.98 649.729 340.83C651.407 341.29 653.139 341.522 654.879 341.52C657.387 341.578 659.882 341.134 662.217 340.214C664.551 339.294 666.679 337.916 668.473 336.162C670.268 334.409 671.694 332.314 672.668 330.001C673.641 327.688 674.143 325.204 674.143 322.695C674.143 320.186 673.641 317.702 672.668 315.389C671.694 313.076 670.268 310.982 668.473 309.228C666.679 307.474 664.551 306.097 662.217 305.176C659.882 304.256 657.387 303.812 654.879 303.87L654.899 303.91ZM630.819 322.46C632.474 322.44 634.12 322.212 635.719 321.78C635.719 322.09 635.719 322.41 635.719 322.78C635.719 322.92 635.719 323.06 635.719 323.2C634.124 322.769 632.481 322.541 630.829 322.52L630.819 322.46Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.318 472.4C952.883 472.403 949.463 472.844 946.138 473.71C946.138 473.11 946.188 472.51 946.188 471.9C946.188 452.28 929.248 436.37 908.348 436.37C887.618 436.37 870.788 452.01 870.508 471.37C849.848 471.64 833.188 487.44 833.188 506.9C833.188 526.36 849.848 542.16 870.508 542.42C870.508 542.59 870.508 542.76 870.508 542.94C870.508 562.56 887.448 578.47 908.358 578.47C929.268 578.47 946.198 562.56 946.198 542.94C946.198 542.67 946.198 542.4 946.198 542.13C949.511 543.001 952.923 543.442 956.348 543.44C977.248 543.44 994.188 527.53 994.188 507.9C994.188 488.27 977.218 472.4 956.318 472.4ZM908.868 507.4C912.126 507.354 915.365 506.918 918.518 506.1C918.518 506.7 918.518 507.3 918.518 507.91C918.518 508.18 918.518 508.44 918.518 508.71C915.373 507.89 912.139 507.457 908.888 507.42L908.868 507.4Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.559 417.07C774.238 417.069 771.927 417.378 769.689 417.99C769.689 417.57 769.689 417.14 769.689 416.72C769.61 410.024 766.907 403.626 762.16 398.902C757.413 394.178 751.002 391.506 744.305 391.46C737.609 391.414 731.162 393.998 726.351 398.657C721.539 403.315 718.749 409.676 718.579 416.37C715.246 416.304 711.934 416.902 708.836 418.132C705.738 419.361 702.916 421.196 700.536 423.529C698.156 425.862 696.265 428.647 694.974 431.72C693.683 434.793 693.018 438.092 693.018 441.425C693.018 444.758 693.683 448.058 694.974 451.131C696.265 454.204 698.156 456.988 700.536 459.321C702.916 461.655 705.738 463.489 708.836 464.719C711.934 465.948 715.246 466.547 718.579 466.48C718.579 466.6 718.579 466.72 718.579 466.84C718.579 473.619 721.272 480.12 726.065 484.914C730.858 489.707 737.36 492.4 744.139 492.4C750.918 492.4 757.419 489.707 762.212 484.914C767.006 480.12 769.699 473.619 769.699 466.84C769.699 466.65 769.699 466.47 769.699 466.28C771.931 466.888 774.235 467.197 776.549 467.2C779.882 467.267 783.196 466.668 786.295 465.438C789.395 464.208 792.217 462.373 794.599 460.039C796.98 457.704 798.871 454.919 800.163 451.845C801.454 448.77 802.119 445.47 802.119 442.135C802.119 438.801 801.454 435.5 800.163 432.426C798.871 429.352 796.98 426.566 794.599 424.232C792.217 421.898 789.395 420.062 786.295 418.832C783.196 417.603 779.882 417.004 776.549 417.07H776.559ZM744.559 441.77C746.733 441.75 748.896 441.461 750.999 440.91C750.999 441.33 750.999 441.75 750.999 442.18C750.999 442.37 750.999 442.56 750.999 442.75C748.88 442.171 746.695 441.865 744.499 441.84L744.559 441.77Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.849 298.46C448.528 298.457 446.217 298.767 443.979 299.38C443.979 298.96 443.979 298.53 443.979 298.1C443.842 291.44 441.112 285.097 436.369 280.419C431.626 275.742 425.246 273.1 418.584 273.055C411.923 273.011 405.508 275.568 400.703 280.182C395.898 284.796 393.084 291.103 392.859 297.76C389.526 297.694 386.214 298.292 383.116 299.522C380.018 300.751 377.196 302.586 374.816 304.919C372.436 307.252 370.545 310.037 369.254 313.11C367.963 316.183 367.298 319.482 367.298 322.815C367.298 326.148 367.963 329.448 369.254 332.521C370.545 335.594 372.436 338.378 374.816 340.711C377.196 343.045 380.018 344.879 383.116 346.109C386.214 347.338 389.526 347.937 392.859 347.87V348.23C392.859 355.009 395.552 361.51 400.345 366.304C405.139 371.097 411.64 373.79 418.419 373.79C425.198 373.79 431.699 371.097 436.493 366.304C441.286 361.51 443.979 355.009 443.979 348.23C443.979 348.04 443.979 347.85 443.979 347.66C446.214 348.273 448.521 348.582 450.839 348.58C457.485 348.58 463.859 345.94 468.559 341.24C473.259 336.541 475.899 330.166 475.899 323.52C475.899 316.874 473.259 310.5 468.559 305.8C463.859 301.1 457.485 298.46 450.839 298.46H450.849ZM418.799 323.16C421.002 323.132 423.194 322.823 425.319 322.24C425.319 322.67 425.319 323.09 425.319 323.52C425.319 323.71 425.319 323.9 425.319 324.09C423.2 323.511 421.016 323.205 418.819 323.18L418.799 323.16Z",
    stroke: "#BD8D0A",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAibr4);
export default __webpack_public_path__ + "static/media/aibr4.523fc0154a69ec50712545eb97269535.svg";
export { ForwardRef as ReactComponent };